export default "__VITE_ASSET__CRueOO5n__"